import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { DEMANDS_INFORMATION_API } from "../api";
import {
  addNewMessage,
  setIsNewForDemandsInformation,
  setIsDataChangedForDemands,
  addSuccessMessage,
  addErrorMessage,
  setDemandsInformationData,
} from "../slice";

export const useDemandsInfo = ({ hasEditAccess, errors }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data, isNew, isDataChanged } = useSelector((state) => state.DemandsInformation);

  const { mutateAsync: addDemandsInformation } = useMutation((data) =>
    DEMANDS_INFORMATION_API.AddDemandsInformation(data)
  );

  const { mutateAsync: editDemandsInformation } = useMutation((data) =>
    DEMANDS_INFORMATION_API.EditDemandsInformation(data)
  );

  const { mutate: getDemandsInformation } = useMutation(
    () => DEMANDS_INFORMATION_API.GetDemandsInformation(),
    {
      onSuccess: ({ data: DemandsInformation }) => {
        if (DemandsInformation.success && DemandsInformation.data) {
          // setIsSpouseEthnicity(DemandsInformation.data.spouseEthnicityMatter);
          dispatch(setDemandsInformationData(DemandsInformation.data));
          // handleGetisNotMatterPriorityId(DemandsInformation.data);
        }
      },
    }
  );

  const countErrors = (errors) => {
    let result = 0;
    Object.keys(errors).forEach((item) => {
      if (errors[item].length !== 0) result += 1;
    });
    return result;
  };

  const handleSubmit = async (route) => {
    var body = { ...data };
    if (countErrors(errors) === 0) {
      if (hasEditAccess && isDataChanged) {
        if (isNew) {
          await addDemandsInformation(body, {
            onSuccess: ({ data }) => {
              if (data.success) {
                dispatch(setIsNewForDemandsInformation(false));
                dispatch(addSuccessMessage(data?.message));
                navigate(route);
              }
            },
            onSettled: () => {
              dispatch(setIsDataChangedForDemands(false));
            },
            onError: ({ response }) => {
              dispatch(addErrorMessage(response));
            },
          });
        } else {
          await editDemandsInformation(body, {
            onSuccess: ({ data }) => {
              if (data.success) {
                dispatch(addSuccessMessage(data?.message));
                navigate(route);
              }
            },
            onSettled: () => {
              dispatch(setIsDataChangedForDemands(false));
            },
            onError: ({ response }) => {
              dispatch(addErrorMessage(response));
            },
          });
        }
      } else {
        navigate(route);
      }
    }
  };
  return { handleSubmit, getDemandsInformation };
};
